"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.06,13.34,13.79,6h0a2.1,2.1,0,0,0-3.1,0L4.43,13.34a2.17,2.17,0,0,0,.16,3,2,2,0,0,0,2.93-.17l4.72-5.54L17,16.14a2,2,0,0,0,1.44.72h.11a2,2,0,0,0,1.39-.56,2.18,2.18,0,0,0,.16-3Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6.4,16.86A2,2,0,0,1,17,16.14L12.24,10.6,7.52,16.14a2,2,0,0,1-2.93.17,2.17,2.17,0,0,1-.16-3L10.69,6a2.1,2.1,0,0,1,3.1,0h0l6.27,7.37a2.18, 2.18,0,0,1-.16,3,2,2,0,0,1-1.39.56Z"
  }));
};

exports["default"] = _default;